import { HeaderButton } from '@/components/HeaderButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { useNavigateToAgentsEditor } from '@/hooks/navigation/useNavigateToAgentsEditor';
import Plus from '@/images/plus.svg';
import { useAnalytics } from '@/services/analytics';
import { useTheme } from '@mui/material';

export const CreateAgentButton = () => {
    const mixpanel = useAnalytics();
    const theme = useTheme();
    const { navigateToAgentEditor, isLoading } = useNavigateToAgentsEditor();

    const handleClick = () => {
        navigateToAgentEditor({ mixPanelFrom: 'agent-library' });
        mixpanel?.track('agent-create', { event: 'click' });
    };

    return (
        <HeaderButton
            id="create-agent-btn"
            onClick={handleClick}
            aria-label="create agent"
            isLoading={isLoading}
            loadingText="Creating agent...">
            <MaskedIcon color={theme.colors.black.main} src={Plus} size="16px" />
            Create agent
        </HeaderButton>
    );
};
